import LoadingSpinner from "@imminently/decisively-ui/LoadingSpinner";
import type { EventConnector } from "@/pages/admin/Settings/settings.api";
import Button from "@imminently/decisively-ui/Button";
import { Plug } from "lucide-react";
import { type MouseEvent, useState } from "react";
import { EventConnectorDialog } from "./EventConnectorDialog";

interface EventConnectorStatusProps {
  eventType?: string;
  connectors: EventConnector[];
  onSetConnector?: (eventType: string) => void;
  showSetConnector?: boolean;
  loading?: boolean;
  error?: boolean;
}

export const EventConnectorStatus = ({ eventType, connectors, onSetConnector, showSetConnector = true, loading, error }: EventConnectorStatusProps) => {
  const [editingConnectorId, setEditingConnectorId] = useState<string>();
  const customEventType = typeof eventType === "string" ? eventType.trim() : "";
  if (!customEventType) return null;
  if (loading) return <span role="status" className="flex items-center gap-2 text-xs text-textSecondary"><LoadingSpinner size="xs" aria-hidden="true" />Loading connectors…</span>;
  if (error) return <span className="text-xs text-textSecondary">Unable to load connectors</span>;
  const connected = connectors.filter(connector => connector.subscribedEvents?.includes(customEventType));
  if (!connected.length && (!onSetConnector || !showSetConnector)) return null;

  return (
    <div className="flex flex-wrap items-center gap-1">
      {editingConnectorId && <EventConnectorDialog connectorId={editingConnectorId} onClose={() => setEditingConnectorId(undefined)} />}
      {connected.length ? connected.map(connector => (
        <Button key={connector.id} size="sm" variant="ghost" intent="secondary" className="h-7 px-2 text-xs"
          label={`Edit ${connector.name || connector.type}`}
          onClick={(event: MouseEvent) => {
            event.stopPropagation();
            setEditingConnectorId(connector.id);
          }}>
          <Plug size={14} /> {connector.name || connector.type}
        </Button>
      )) : (
        <Button size="sm" variant="ghost" intent="secondary" className="h-7 px-2 text-xs" label="Set connector"
          onClick={(event: MouseEvent) => {
            event.stopPropagation();
            onSetConnector?.(customEventType);
          }}>
          <Plug size={14} /> Set connector
        </Button>
      )}
    </div>
  );
};
